import { render, staticRenderFns } from "./ExpenseItemDataPropagation.vue?vue&type=template&id=4eee706e&"
import script from "./ExpenseItemDataPropagation.vue?vue&type=script&lang=js&"
export * from "./ExpenseItemDataPropagation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports